<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-i">
<div class="section level2" id="section-6">
<h2><br/><br/><br/>7</h2>
<p><br/><br/><br/>We had anchored, all of us and we were in the centre as everyone else had moved forward. We sent down divers to look for remnants of the ship. In the distance, a squid moved a giant tail, about twenty feet long, black and belonging to fins, and the earth shook softly beneath us and set off a series of rocket sensors and lights began beeping and horns began flashing in one of the other boats.</p>
<p>“The sensors! The sensors!” the captain of their vessel screamed. I was getting deep into this sea captain bit when they arrived back up and told us that there were no remains, and there were small sheets of black fin scattered across the floor of the ocean beneath us. The water had grown darker. There was no way to know where they went. The blue of the sea stretched far and wide. There was emptiness and a small but loud gurgle.</p>
<p>“Where are they?” Wendy asked.</p>
<p>“Don’t know,” I said. And I didn’t.</p>
<p>The ship was once there but now it wasn’t. The whole crew evaporated into nothingness, vaporised. We made a call to the submarines to rise up to the surface. They came back to the surface and started popping out the top of their vessels. One of them had seen nothing and the other had seen the broken boat in the arms of a quick moving giant serpent that sped back through the bottom of the floor.</p>
<p>“Where the <em>fuck</em> did they go?” Q screamed off of his boat.</p>
<p>“I don’t know!” I screamed back.</p>
<p>“They have got to be here somewhere,” Trish said.</p>
<p>“Somewhere, anywhere,” Wendy said.</p>
<p>“Where did he go, baby?” asked one of the Rasta women to Q.</p>
<p>“I don’t know, baby,” he said back to her.</p>
<p>We looked around and a couple of the ships had just begun to send out divers. Two of them splashed down while people held their oxygen lines and lowered them into the water, beige and green, murky all of a sudden. They splashed down.</p>
<p>“Oh no!” people were crying out. It did not look good.</p>
<p>After about two hours, a huge team recovered little other than some wood and pieces of the sail. We eventually moved on.</p>
<p>We got about forty minutes when the boat shook again. We got another twenty minutes when one of the subs, riding up top with us now, was grasped by a long black arm, wrapping around the machine.</p>
<p>Fins and tentacles clawed at the boat and a giant, spider-like water creature wrapped around the cockpit, from a piece of the arm or maybe it was the head of the creature. It started dragging it down, as the other arms were flailing.</p>
<p>Someone shot a laser at it off of their boat, held on with an easel, like a small ray gun. The nuclear ray rattled the top of the vessel and it unhanded it, the arms of the giant octopus flailing more. People shot at it with a machine gun and more lasers from their vessels.</p>
<p>The octopus dropped the sub and people came out of the top with spears, riding on the wall over the sea.</p>
<p>Some of them started swinging at it and it swam off, diving down into the water.</p>
<p>Divers jumped off to chase the alien octopus, or whatever it was. They watched it swim away at the speed of sound.</p>
<p>They came back up, we all transformed into a submarine while the rest of the group washed up on a nearby island to wait for us. We were going to sink down into the sea and find our allies, our makers and those who had given us our lives and resources, the mermaids and Triton.</p>
<p>We sat there, transforming and watching the boats sail away to find the new island, while they waited for us to someday, sometime return.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?233b432c